import { IPerson } from "../../../api/types";
import { S3Image, TeamCover } from "../../../components/S3Image";

const roleLabels = {
  manager: "Manager",
  coach: "Coach",
  physio: "Kiné",
  assistant: "Assistant",
  player: "Joueur",
};

interface TeamGridProps {
  callout: string;
  title: string;
  subTitle?: string;
  persons: IPerson[];
  backgroundImage?: string;
}

export default function TeamGrid({
  title,
  callout,
  subTitle,
  persons,
  backgroundImage,
}: TeamGridProps) {
  const isMensTeam = title.includes("Garçons");
  const players = persons.filter((person) => person.role === "player");
  const others = persons.filter((person) => person.role !== "player");

  return (
    <div className="pb-16">
      <div className="relative bg-white py-24 sm:py-32">
        {backgroundImage && (
          <div className="absolute inset-0 overflow-hidden">
            <TeamCover
              keyPath={backgroundImage}
              alt={`${title} team cover`}
              className="absolute inset-0 bg-cover bg-center ml-96"
            />
            <div
              className="absolute inset-0 bg-white bg-opacity-100"
              style={{
                clipPath: "polygon(0 0, 75% 0, 50% 100%, 0% 100%)",
              }}
            />
          </div>
        )}

        <div className="relative mx-auto max-w-7xl px-6 lg:px-8">
          <div className="mx-auto max-w-2xl lg:mx-0">
            <p className="text-base/7 font-semibold text-indigo-600">
              {callout}
            </p>
            <h2 className="mt-2 text-5xl font-semibold tracking-tight text-gray-900 sm:text-7xl">
              {title}
            </h2>
            <p className="mt-8 text-pretty text-lg font-medium text-gray-500 sm:text-xl/8">
              {subTitle}
            </p>
          </div>
        </div>
      </div>
      <ul className="mx-auto mt-20 grid max-w-2xl grid-cols-2 gap-x-8 gap-y-16 text-center sm:grid-cols-3 md:grid-cols-4 lg:mx-0 lg:max-w-none lg:grid-cols-5 xl:grid-cols-6">
        {others.map((person) => (
          <li key={person._id}>
            <div className="transition duration-150 ease-out hover:ease-in">
              <S3Image
                keyPath={person.image_key}
                alt={person.lastname}
                className="mx-auto w-24 h-24"
                fallbackSrc="/assets/men-placeholder.png"
              />
            </div>
            <h3 className="mt-6 text-base/7 font-semibold tracking-tight text-gray-900">
              {person.lastname}
            </h3>
            <p className="text-sm/6 text-gray-600">
              {roleLabels[person.role as keyof typeof roleLabels]}
            </p>
          </li>
        ))}
        {players.map((person) => (
          <li key={person._id}>
            <div className="transition duration-150 ease-out hover:ease-in">
              <S3Image
                keyPath={person.image_key}
                alt={person.lastname}
                className="mx-auto w-24 h-24"
                fallbackSrc={
                  // @TODO: Support gender on the person level
                  isMensTeam
                    ? "/assets/men-placeholder.png"
                    : "/assets/women-placeholder.png"
                }
              />
            </div>
            <h3 className="mt-6 text-base/7 font-semibold tracking-tight text-gray-900">
              {person.lastname}
            </h3>
            <p className="text-sm/6 text-gray-600">#{person.number}</p>
          </li>
        ))}
      </ul>
    </div>
  );
}
